import { Injectable } from '@angular/core';
import {
  GetCustomizationDataGQL,
  GetCustomizationDataQuery,
  GetPreferenceDataGQL,
} from '../../../generated/types';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { WindowService } from './window-service';

@Injectable({
  providedIn: 'root',
})
export class CustomizationDataService {
  constructor(
    private getCustomizationDataGQL: GetCustomizationDataGQL,
    private getPreferenceDataGQL: GetPreferenceDataGQL,
    private windowService: WindowService
  ) {}

  private static isCustomUrl(frontUrl: string): boolean {
    let isCustom = true;
    if (environment.notCustomUrl) {
      isCustom = !environment.notCustomUrl.includes(frontUrl);
    }
    return isCustom;
  }

  private getPersonalizationUrls(): Observable<string[]> {
    return this.getPreferenceDataGQL.fetch().pipe(
      map((value) => {
        return (
          value.data.authenticatedUser.memberOf
            ?.map((memberOf) => {
              return memberOf.preference?.frontUrl ?? '';
            })
            .filter((value1) => value1 !== '') ?? []
        );
      })
    );
  }

  redirectToPerso(): void {
    this.getPersonalizationUrls()?.subscribe(
      (preferenceList) => {
        if (
          preferenceList.length === 0 ||
          preferenceList.includes(this.windowService.getWindowOrigin())
        ) {
          return;
        }
        this.windowService.navigateToUrl(preferenceList[0]);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getCustomizationData(): Observable<
    GetCustomizationDataQuery['preference'] | null
  > {
    const url = this.windowService.getWindowOrigin();
    if (CustomizationDataService.isCustomUrl(url)) {
      return this.getCustomizationDataGQL.fetch({ frontUrl: url }).pipe(
        map((response) => response.data.preference),
        catchError((error) => {
          console.warn(error);
          return of(null);
        })
      );
    }
    return of(null);
  }
}
